/* Olivia & Jack V12: image size-chart dialog; delegated for Shopify section morphs */
(() => {
  'use strict';
  if (window.__ojSizeChartsReady) return;
  window.__ojSizeChartsReady = true;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const open = event.target.closest('[data-oj-size-chart-open]');
    if (open) {
      event.preventDefault();
      const dialog = document.getElementById(open.dataset.ojSizeChartOpen || '');
      if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-oj-size-chart-close]');
    if (close) {
      event.preventDefault();
      close.closest('dialog')?.close();
      return;
    }
    if (event.target.matches('dialog.oj-size-chart-dialog')) event.target.close();
  });
})();
